import { render, staticRenderFns } from "./StandardSearch.vue?vue&type=template&id=1f91516c&scoped=true"
import script from "./StandardSearch.vue?vue&type=script&lang=js"
export * from "./StandardSearch.vue?vue&type=script&lang=js"
import style0 from "./StandardSearch.vue?vue&type=style&index=0&id=1f91516c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91516c",
  null
  
)

export default component.exports